import type { ReactNode } from 'react';
import { PodcastWrapper, Title, Description, IFrame } from '../styled';

interface Props {
  title: string;
  description: ReactNode;
  podcastUrl: string;
}

const Podcast = ({ title, description, podcastUrl }: Props) => {
  return (
    <PodcastWrapper>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <IFrame
        title={title}
        allow="autoplay *; encrypted-media *; fullscreen *"
        frameBorder="0"
        height="175"
        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation"
        src={podcastUrl}
      />
    </PodcastWrapper>
  );
};

export default Podcast;
